import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useThemeContext } from "@circle-react/providers/Theme";
import type { CurrentCommunity } from "@circle-react/types/CurrentCommunity";

import { t } from "@/i18n-js/instance";
import {
  anchorClassNames,
  legacyClassNames,
} from "@/react/helpers/cssAnchorHelpers";

export interface CommunityBrandProps {
  currentCommunity?: CurrentCommunity;
}

export const CommunityBrand = ({ currentCommunity }: CommunityBrandProps) => {
  const { isDarkAppearance } = useThemeContext();

  const {
    name: communityName,
    logo_url: lightLogoUrl,
    dark_logo_url: darkLogoUrl,
  } = currentCommunity || {};
  let communityLogoUrl = lightLogoUrl;

  if (isDarkAppearance && darkLogoUrl) {
    communityLogoUrl = darkLogoUrl;
  }

  if (communityLogoUrl) {
    return (
      <a href="/" className={anchorClassNames("community__brand")}>
        <div className={anchorClassNames("community__logo")}>
          <img
            loading="lazy"
            alt={t("community_logo_alt", { community_name: communityName })}
            src={communityLogoUrl}
          />
        </div>
      </a>
    );
  }

  return (
    <a href="/" className={anchorClassNames("community__brand")}>
      <div
        className={classNames(
          anchorClassNames("brand-icon"),
          legacyClassNames("brand-icon__initial"),
          "!rounded-lg",
        )}
      />
      <div className={anchorClassNames("name")}>{communityName}</div>
    </a>
  );
};
